import { useEffect } from 'react';
import { usePublicConfig } from '@pv/common/providers';

const HubSpot = () => {
  const { publicConfig } = usePublicConfig();
  const email = publicConfig?.hubspotUserEmail;

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      if (email) {
        window._hsq = window._hsq || [];
        const { _hsq } = window;
        _hsq.push(['identify', { email }]);
        _hsq.push(['trackPageView']);
      }
    }
  }, [email]);

  return null;
};

export default HubSpot;
